export class LastDetectTag {

  public value: string;

  public time: number;

  public toDelete: boolean = false;

  constructor(value: string, time: number) {
    this.value = value;
    this.time = time;
  }
}



// WEBPACK FOOTER //
// ./src/models/LastDetectTag.ts